export const CHANNEL_NAME = 'reports-designer-filters';
